function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#516e85"
}, /*#__PURE__*/React.createElement("path", {
  d: "m29.496 32h-26.992c-1.38 0-2.504-1.123-2.504-2.504v-24.991c0-1.381 1.124-2.505 2.505-2.505h26.99c1.381 0 2.505 1.124 2.505 2.505v24.991c0 1.381-1.123 2.504-2.504 2.504zm-26.991-28c-.278 0-.505.227-.505.505v24.991c0 .278.226.504.504.504h26.992c.278 0 .504-.226.504-.504v-24.991c0-.278-.227-.505-.505-.505zm28.495 6h-30c-.552 0-1-.448-1-1s.448-1 1-1h30c.553 0 1 .448 1 1s-.447 1-1 1zm-25-4c-.552 0-1-.448-1-1v-4c0-.552.448-1 1-1s1 .448 1 1v4c0 .552-.448 1-1 1zm20 0c-.553 0-1-.448-1-1v-4c0-.552.447-1 1-1s1 .448 1 1v4c0 .552-.447 1-1 1z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 18,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 22,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 6,
  cy: 26,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 14,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 18,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 26,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 14,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 18,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 22,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 18,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 22,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 26,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 14,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 18,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 22,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 26,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 14,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 18,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 22,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 26,
  r: 1
}));

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.3b6d5926.svg";
export { ForwardRef as ReactComponent };